module.exports = __webpack_public_path__ + "img/11_5.aae29b9e.png";